import React from "react";
import "../../../assets/css/table/Pagination.css";
import ChevronDown from "../../Atomos/Icons/ChevronDown";
import { useStaffMode } from "../../../hooks/StaffModeProvider";
import {
  TABLE_PAGE_SIZE_OPTIONS,
  normalizeTablePageSize,
} from "../../../constants/tablePagination";

interface IPaginationComponentProps {
  onPageChange: (pageNumber: number, pageSize: number) => void;
  totalCount: number;
  currentPage: number;
  recordsPerPage: number;
}

const PaginationComponent: React.FC<IPaginationComponentProps> = ({
  totalCount,
  onPageChange,
  currentPage,
  recordsPerPage,
}) => {
  const { isStaffMode } = useStaffMode();
  const normalizedPageSize = normalizeTablePageSize(recordsPerPage);
  const totalPageCount = Math.ceil(totalCount / normalizedPageSize);
  const selectValue = normalizedPageSize;

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1, normalizedPageSize);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPageCount) {
      onPageChange(currentPage + 1, normalizedPageSize);
    }
  };

  const handleFirstPage = () => {
    if (currentPage !== 1) {
      onPageChange(1, normalizedPageSize);
    }
  };

  const handleLastPage = () => {
    if (currentPage !== totalPageCount) {
      onPageChange(totalPageCount, normalizedPageSize);
    }
  };

  return (
    <div className="pagination py-6">
      <div className="pagination-label-clip">
        <label
          htmlFor="records-per-page"
          className="records-per-page"
          title="Rows per Page"
        >
          Rows per Page
        </label>
      </div>
      <div className="relative flex shrink-0 justify-center items-center bg-gray-25">
        <select
          id="records-per-page"
          name="records-per-page"
          className="selectorPageSize"
          value={selectValue}
          onChange={(e) => {
            onPageChange(1, Number(e.target.value));
          }}
        >
          {TABLE_PAGE_SIZE_OPTIONS.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
        <div className="pointer-events-none">
          <div className="absolute h-6 w-6 right-2 top-2 fill-gray-font">
            <ChevronDown />
          </div>
        </div>
      </div>

      <div className="flex shrink-0 flex-nowrap items-center gap-4">
        <button type="button" className="arrow" onClick={handlePreviousPage}>
          &lt;
        </button>

        {currentPage !== 1 && (
          <>
            <button type="button" className="button" onClick={handleFirstPage}>
              1
            </button>
            {currentPage - 2 > 1 && (
              <span className="text-lg font-semibold">...</span>
            )}
          </>
        )}

        {currentPage - 1 > 1 && (
          <button type="button" className="button" onClick={handlePreviousPage}>
            {currentPage - 1}
          </button>
        )}

        <button
          type="button"
          className={`currentButton ${isStaffMode ? "bg-Default" : "bg-primary"}`}
        >
          {currentPage}
        </button>

        {currentPage + 1 < totalPageCount && (
          <button type="button" className="button" onClick={handleNextPage}>
            {currentPage + 1}
          </button>
        )}

        {currentPage + 2 < totalPageCount && (
          <span className="text-lg font-semibold">...</span>
        )}

        {totalPageCount !== currentPage && totalPageCount > 1 && (
          <button type="button" className="button" onClick={handleLastPage}>
            {totalPageCount}
          </button>
        )}

        <button type="button" className="arrow" onClick={handleNextPage}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
